import React from 'react';
import { useIntl } from 'react-intl-next';

import { Field, ErrorMessage } from '@atlaskit/form';
import Skeleton from '@atlaskit/skeleton';
import type { DocNode } from '@atlaskit/adf-schema';

import { LoadableAfterPaint } from '@confluence/loadable';

import { messages } from '../../messages';

const LoadingSkeleton = () => <Skeleton width="200px" height="16px" testId="skeleton" />;

const LazyEditorComponent = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-EditorComponent" */ './EditorComponent'))
			.EditorComponent,
	loading: LoadingSkeleton,
});

export type RichTextFieldProps = {
	value?: DocNode;
	label?: string;
	name?: string;
	testId?: string;
	onChange?: (value: DocNode) => void;
	isDisabled?: boolean;
	isRequired?: boolean;
};

export const RichTextField = ({
	value,
	label,
	name = 'description',
	testId = 'work-create-form-description-field',
	onChange,
	isDisabled = false,
	isRequired = false,
}: RichTextFieldProps) => {
	const { formatMessage } = useIntl();

	const defaultLabel = formatMessage(messages.workCreateCommonDescriptionLabel);

	return (
		<Field name={name} label={label || defaultLabel} testId={testId} isRequired={isRequired}>
			{({ fieldProps: { id }, error }) => (
				<>
					<LazyEditorComponent
						id={id}
						initialValue={value}
						onChange={onChange}
						isDisabled={isDisabled}
					/>
					{error && <ErrorMessage>{error}</ErrorMessage>}
				</>
			)}
		</Field>
	);
};
